(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    class MwCompactNavigation extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.topLevelDetails = Array.from(this.querySelectorAll('.mw-compact-nav__item > .mw-compact-nav__details'));
      this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleLinkClick = this.handleLinkClick.bind(this);
      this.handleToggle = this.handleToggle.bind(this);

      this.topLevelDetails.forEach((details) => details.addEventListener('toggle', this.handleToggle));
      this.addEventListener('keydown', this.handleKeyDown);
      this.addEventListener('click', this.handleLinkClick);
      document.addEventListener('pointerdown', this.handleDocumentPointerDown);
    }

    disconnectedCallback() {
      this.topLevelDetails?.forEach((details) => details.removeEventListener('toggle', this.handleToggle));
      this.removeEventListener('keydown', this.handleKeyDown);
      this.removeEventListener('click', this.handleLinkClick);
      document.removeEventListener('pointerdown', this.handleDocumentPointerDown);
    }

    handleToggle(event) {
      const currentDetails = event.currentTarget;

      if (currentDetails.open) {
        this.topLevelDetails.forEach((details) => {
          if (details !== currentDetails) details.removeAttribute('open');
        });
      } else {
        currentDetails.querySelectorAll('.mw-compact-nav__branch[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    }

    handleDocumentPointerDown(event) {
      if (!this.contains(event.target)) this.closeAll();
    }

    handleKeyDown(event) {
      if (event.key !== 'Escape') return;

      const openDetails = Array.from(this.querySelectorAll('details[open]'));
      const lastOpenDetails = openDetails.at(-1);

      if (!lastOpenDetails) return;

      event.preventDefault();
      lastOpenDetails.removeAttribute('open');
      lastOpenDetails.querySelector(':scope > summary')?.focus();
    }

    handleLinkClick(event) {
      if (event.target.closest('a')) this.closeAll();
    }

    closeAll() {
      this.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
    }
  }

  if (!customElements.get('mw-compact-navigation')) {
    customElements.define('mw-compact-navigation', MwCompactNavigation);
  }
  } catch(e) { console.error(e); }
})();

})();
